module.exports = __webpack_public_path__ + "img/32.07ecf1c3.jpg";